import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Digital_add_pro extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subcategory: [],
            categories: [],
        }
        this.submitHandler = this.submitHandler.bind(this)
    }

    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }

        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        fetch(`${process.env['REACT_APP_HOST']}/api/subcategories/${lastItem}`)
            .then((response) => response.json())
            .then(result => {
                console.log("subcategory")
                console.log(result)
                this.setState({ 
                    subcategory: result,
                    subcategory_ParentId: result,
                
                });
            });

        fetch(`${process.env['REACT_APP_HOST']}/api/categories`)
            .then((response) => response.json())
            .then(result => {
                this.setState({ categories: result.categoryList });

            });
    }

    changeParent=(e)=>{
      console.log("e")
      console.log(e)
      this.setState({ 
        subcategory_ParentId: e
     });
    }



    submitHandler(e) {
        e.preventDefault();
        const current = this;
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        const url = `${process.env['REACT_APP_HOST']}/api/categories/${lastItem}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: e.target.name.value,
                parentId: current.state.subcategory_ParentId
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                toast.success(data)
                setTimeout(() => {
                    this.props.history.push(`${process.env.PUBLIC_URL}/products/digital/digital-sub-category`);
                }, 3000);

            })
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Edit Subcategory" parent="Digital" />
                <ToastContainer />
                <div className="container-fluid">
                    <div className="row product-adding">
                        <div className="col-xl-6">
                            <div className="card">
                                <div className="card-body">
                                    <form method="post" action="" onSubmit={this.submitHandler}>
                                        <div className="digital-add needs-validation">
                                            <div className="form-group">
                                                <label htmlFor="recipient-name" className="col-form-label" >Sub Category Name </label>
                                                <input type="text" name="name" defaultValue={this.state.subcategory.name} onChange={(e) => this.setState({ name: e.target.value })} className="form-control" required="required"></input>
                                            </div>

                                            <div className="form-group">
                                                <label className="col-form-label">Category</label>
                                                {/* <select className="custom-select" name="parentId" value={this.state.subcategory_ParentId} onChange={(e) => this.setState({ subcategory_ParentId: e.target.value })} > */}
                                                <select className="custom-select" name="parentId" value={this.state.subcategory_ParentId} onChange={(e) => this.changeParent(e.target.value)} >
                                                    {/* <option value="0">--Select--</option> */}

                                                    {this.state.categories.map(category => {
                                                        return category.id == this.state.subcategory_ParentId ?
                                                            <option value={category.id} selected="selected">{category.name}</option> :
                                                            <option value={category.id}>{category.name}</option>
                                                    })}
                                                </select>
                                            </div>

                                            <br></br>
                                            <div className="form-group mb-0">
                                                <div className="product-buttons text-center">
                                                    <input type="submit" name="submit" value="Update" className="btn btn-primary" />
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Digital_add_pro
